import { Button, Box } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import moment from 'moment-timezone';

import { Modal } from 'components/Modal/Modal';
import { GuidancePageCoupon } from 'models/guidancePage';
import { redeemCoupon } from 'ducks/client/coupons';
import { ApiKeyContext } from 'contexts/ApiKeyContext';
import { ReduxState } from 'ducks';

import styles from './CouponModal.module.css';
import { triggerSalesOffer } from 'ducks/client/salesOffers';

interface OwnProps {
  onClose: () => void;
  open: boolean;
  coupon: GuidancePageCoupon;
  pageId: string;
}

type Props = OwnProps;

export const CouponModal = ({ coupon, onClose, open, pageId }: Props) => {
  const dispatch = useDispatch();
  const { apiKey } = React.useContext(ApiKeyContext);
  const router = useRouter();

  const [submittedTime, setSubmittedTime] = React.useState('');

  const submitting = useSelector((state: ReduxState) => state.coupons.loading);

  const reservationId = router.query?.r as string;

  const { t } = useTranslation();

  return (
    <Modal
      onClose={() => {
        dispatch(
          triggerSalesOffer({
            triggerType: 'ONLINE_GUIDE_AFTER_COUPON_REDEMPTION',
            couponId: coupon.id,
          })
        );
        onClose?.();
      }}
      open={open}
    >
      <Box className={styles['title']} display="flex" justifyContent="center">
        <h1>{coupon.title}</h1>
      </Box>
      {submittedTime ? (
        <Box mt={1}>
          <Box mt={2} display="flex" justifyContent="center">
            <div>
              <img height={200} width={200} src="/static/images/ic_thankyou.png" />
            </div>
          </Box>
          <Box mt={1} display="flex" justifyContent="center">
            {t('Time of use: {{time}}', { time: submittedTime })}
          </Box>
        </Box>
      ) : (
        <>
          <Box mt={1}>
            <p className="newline">{coupon.description}</p>
          </Box>
          <Box display="flex" justifyContent="center" mt={2}>
            <Button
              disabled={!reservationId || submitting}
              onClick={async () => {
                await dispatch(
                  redeemCoupon(apiKey, {
                    reservation_id: reservationId,
                    coupon_id: coupon.id,
                    page_id: pageId,
                  })
                );
                const now = moment().format('YYYY/MM/DD HH:mm');
                setSubmittedTime(now);
              }}
              variant="contained"
              color="primary"
            >
              {t('Use Coupon')}
            </Button>
          </Box>
        </>
      )}
    </Modal>
  );
};
